// extracted by mini-css-extract-plugin
export default {"mainDivSendMails":"sendReminder_mainDivSendMails__PLyOS","emailUserIconDiv":"sendReminder_emailUserIconDiv__25RLT","shortNameDiv":"sendReminder_shortNameDiv__fvLSW"};